import BuySideTeams from './BuySideTeams.page';

export default BuySideTeams;
